import { render } from "./CourseManagementCard.vue?vue&type=template&id=fbe03a50"
import script from "./CourseManagementCard.vue?vue&type=script&lang=js"
export * from "./CourseManagementCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__